import {combineReducers} from 'redux'
import reduceReducers from 'reduce-reducers'
import {
  ADD_CARD_TO_BOARD,
  SET_RULES,
  SET_PLAYERS_COUNT,
  SET_ACTIVE_FIELD,
  GET_WINNER_HAND,
  SET_BOARD_PLAYERS,
  UPDATE_ACTIVE_FIELD,
  SET_BOARD_CAROUSEL,
  RESET,
} from '../constants/actionTypes'
import {
  getTableCards,
  transformCardToService,
  transformCardFromService,
  getPlayerFromId,
  getActiveOption,
  isObjectsSame,
  getNearestEmptyCard,
  getNextEmptyCard,
  whichHandWinsValidation,
} from '../helpers/common'
import {
  changePlayersCount,
  getBoardData,
  getTableData,
  setPlayersSettings,
} from '../helpers/players'
import {
  setCardActive
} from '../helpers/reduceReducers'
import menu from './menu'
import board from './board'
import hints from './hints'
import {fromJS} from 'immutable'
import {Game} from '../services/handwinService'
import {
  gameIdToServiceTransformer,
} from '../constants/cardTransformers'
import {
  gameSettings,
  tableData,
} from '../constants/initialData'
import {showHint} from '../helpers/reduceReducers'
import {
  FLOP_TYPE,
  TABLE,
} from '../constants/board'
import {
  TYPE_HINT_ERROR,
  TYPE_PLAYER,
} from '../constants/types'
import {menuInitialState} from '../helpers/menu';

const addCardToBoard = (state, {rank, suit, active}) => {
  const board = state.board.toJS();
  const players = board.players;
  const table = board.table;
  const activeField = board.activeField;
  const chosenCardId = activeField.card.id;
  const chosenFieldId = activeField.id;
  let menuState;

  if (activeField) {
    if (activeField.type === 'player') {
      if (players[chosenFieldId]) {
        const hand = players[chosenFieldId].hand;

        if (!hand[chosenCardId]) {
          hand[chosenCardId] = {
            rank: rank,
            suit: suit
          };
          menuState = setCardActive(state.menu, {rank, suit, active});
        }
      }
    } else if (activeField.type === 'table' && Object.keys(table).length) {
      switch (activeField.card.type) {
        case 'flop':
          if (!table[activeField.card.type][activeField.card.id]) {
            table[activeField.card.type][activeField.card.id] = {
              rank: rank,
              suit: suit
            };
            menuState = setCardActive(state.menu, {rank, suit, active});
          }
          break;
        case 'turn':
          if (!table[activeField.card.type]) {
            table[activeField.card.type] = {
              rank: rank,
              suit: suit
            };
            menuState = setCardActive(state.menu, {rank, suit, active});
          }
          break;
        case 'river':
          if (!table[activeField.card.type]) {
            table[activeField.card.type] = {
              rank: rank,
              suit: suit
            };
            menuState = setCardActive(state.menu, {rank, suit, active});
          }
          break;
        default:
          break;
      }
    }
  }

  return {
    hints: state.hints,
    menu: menuState || state.menu,
    board: fromJS({
      table,
      players,
      activeField,
      winner: state.board.get('winner'),
    }),
    settings: state.settings,
  };
};

const updateActiveField = (state) => {
  const board = state.board.toJS();
  const players = board.players;
  const table = board.table;
  const activeField = board.activeField;
  const chosenFieldId = activeField.id;
  let nearestEmptyField;

  if (activeField) {
    if (activeField.type === 'player') {
      if (players[chosenFieldId]) {
        nearestEmptyField = getNearestEmptyCard(players, table, activeField);

        if (nearestEmptyField) {
          activeField.type = nearestEmptyField.type;
          activeField.id = nearestEmptyField.id;
          activeField.card.id = nearestEmptyField.card.id;
          activeField.card.type = nearestEmptyField.card.type;
        }
      }
    } else if (activeField.type === 'table' && Object.keys(table).length) {
      switch (activeField.card.type) {
        case 'flop':
          nearestEmptyField = getNextEmptyCard(players, table, activeField);

          if (nearestEmptyField) {
            activeField.type = nearestEmptyField.type;
            activeField.id = nearestEmptyField.id;
            activeField.card.id = nearestEmptyField.card.id;
            activeField.card.type = nearestEmptyField.card.type;
          }
          break;
        case 'turn':
          nearestEmptyField = getNextEmptyCard(players, table, activeField);

          if (nearestEmptyField) {
            activeField.type = nearestEmptyField.type;
            activeField.id = nearestEmptyField.id;
            activeField.card.id = nearestEmptyField.card.id;
            activeField.card.type = nearestEmptyField.card.type;
          }
          break;
        case 'river':
          nearestEmptyField = getNextEmptyCard(players, table, activeField);
          if (nearestEmptyField) {
            activeField.type = nearestEmptyField.type;
            activeField.id = nearestEmptyField.id;
            activeField.card.id = nearestEmptyField.card.id;
            activeField.card.type = nearestEmptyField.card.type;
          }
          break;
        default:
          break;
      }
    }
  }

  const everythingChosen = whichHandWinsValidation(players, table);
  if (everythingChosen) {
    activeField.type = false;
    activeField.id = false;
    activeField.card.id = false;
    activeField.card.type = false;
  }
  return {
    hints: state.hints,
    menu: state.menu,
    board: fromJS({
      table,
      players,
      activeField,
      winner: state.board.get('winner'),
    }),
    settings: state.settings,
  };
};

const setActiveField = (state, {type, id, isCardClicked}) => {
  const activeField = state.board.get('activeField').toJS();
  activeField.id = --id;
  activeField.type = type;
  if (!isCardClicked) {
    activeField.card.id = 0;
    activeField.card.type = type === TABLE ? FLOP_TYPE : TYPE_PLAYER;
  }

  return {
    ...state,
    board: state.board.set('activeField', fromJS(activeField))
  };
};

export const resetMenu = (state) => {
  const settings = state.settings.toJS();
  const activeRules = getActiveOption(settings.rules).rules;
  const board = getBoardData(
    getActiveOption(settings.players).id,
    activeRules.numberOfCardsInHand,
    getTableData(activeRules.numberOfCardsOnBoard));
  board.carousel = {hasChanged: true, reset: true,};

  return {
    ...state,
    menu: menuInitialState,
    board: fromJS(board),
  }
};

const setBoardPlayers = (state, payload) => {
  return {
    ...state,
    board: state.board.set('players', fromJS(payload.players))
  };
};

const setBoardCarousel = (state, payload) => {
  return {
    ...state,
    board: state.board.set('carousel', fromJS(payload))
  };
};

const getWinnerHand = (state) => {
  const board = state.board.toJS();
  if (whichHandWinsValidation(board.players, board.table)) {
    const board = state.board;
    const boardPlayers = board.get('players').toJS();
    const table = getTableCards(board.get('table').toJS());
    const gameName = gameIdToServiceTransformer[getActiveOption(state.settings.get('rules').toJS()).id];
    const players = boardPlayers.map((player) => {
      return {
        hand: {
          cards: player.hand.map((card) => {
            return transformCardToService(card)
          })
        },
        id: player.id
      }
    });
    const winners = (new Game(players, table, gameName)).getWinners().winnerResult;
    const firstWinner = winners[0];
    const winnersNames = winners.map(winner => {
      return getPlayerFromId(boardPlayers, winner.playerId);
    }).join(', ');
    const winnersIds = winners.map(winner => winner.playerId);

    const newBoard = board.toJS();
    newBoard.winner = {
      combination: firstWinner.handName,
      name: winners.length === 1
        ? getPlayerFromId(boardPlayers, firstWinner.playerId) + ' Wins!'
        : 'Split Pot - ' + winnersNames,
      cards: firstWinner.result.map(card => {
        return transformCardFromService(card);
      }),
      ids: winnersIds
    };
    newBoard.carousel = {hasChanged: true};
    return {
      ...state,
      board: fromJS(newBoard),
    }
  }
  return {
    ...state,
    hints: showHint(state.hints, {type: TYPE_HINT_ERROR})
  };
};

const setRules = (state, {id}) => {
  const settings = state.settings;
  const board = state.board.toJS();
  const isPOC = settings.get('id') === 'poc';
  const rules = settings.get('rules').toJS().map(rule => {
    return {
      ...rule,
      active: false
    }
  });
  const currentPlayersId = getActiveOption(settings.get('players').toJS()).id;
  const activeRule = rules.find(rule => rule.id === id);
  activeRule.active = true;
  const settingsPlayers = setPlayersSettings(activeRule.rules.minPlayers, activeRule.rules.maxPlayers, currentPlayersId);
  const players = changePlayersCount(
    [],
    getActiveOption(settingsPlayers).id,
    getActiveOption(rules).rules.numberOfCardsInHand
  );
  board.players = fromJS(players);
  board.table = fromJS(getTableData(activeRule.rules.numberOfCardsOnBoard));
  if (isPOC) {
    board.activeField = {
      type: 'player',
      id: 0,
      card: {
        type: 'player',
        id: 0,
      }
    }
  } else {
    board.activeField = getNearestEmptyCard(players, tableData, board.activeField);
  }
  board.winner = false;

  return {
    ...state,
    board: fromJS(board),
    settings: fromJS({
      id: settings.get('id'),
      rules: fromJS(rules),
      players: fromJS(settingsPlayers),
    })
  };
};

const setPlayersCount = (state, {id}) => {
  const settings = state.settings;
  const menuCards = state.menu.toJS();
  const board = state.board.toJS();
  const players = settings.get('players').toJS().map(player => {
    return {
      ...player,
      active: false
    }
  });
  const currentPlayers = state.board.get('players').toJS();
  const countDifference = id - currentPlayers.length;
  if (countDifference <= 0) {
    let i = 0;
    for (i; i < Math.abs(countDifference); ++i) {
      currentPlayers[currentPlayers.length - i - 1].hand.map((card) => {
        let i = 0;
        for (i; i < menuCards.length; ++i) {
          const cardIndex = menuCards[i].findIndex((menuCard) => {
            return isObjectsSame({...card, active: true}, menuCard)
          });

          if (cardIndex !== -1) {
            menuCards[i][cardIndex].active = false;
            break;
          }
        }
        return {
          ...card
        }
      });
    }
  }

  const newPlayers = changePlayersCount(
    currentPlayers,
    countDifference,
    getActiveOption(settings.get('rules').toJS()).rules.numberOfCardsInHand
  );

  players.find(rule => rule.id === id).active = true;
  board.activeField = getNearestEmptyCard(newPlayers, board.table, board.activeField);
  board.players = fromJS(newPlayers);
  board.winner = false;

  return {
    ...state,
    menu: fromJS(menuCards),
    board: fromJS(board),
    settings: settings.set('players', fromJS(players))
  };
};

export default reduceReducers(
  combineReducers({
    menu,
    board,
    hints,
    settings(state = fromJS(gameSettings)) {
      return state
    }
  }),
  (state, action) => {
    switch (action.type) {
      case ADD_CARD_TO_BOARD:
        return addCardToBoard(state, action.payload);
      case UPDATE_ACTIVE_FIELD:
        return updateActiveField(state);
      case SET_BOARD_PLAYERS:
        return setBoardPlayers(state, action.payload);
      case SET_BOARD_CAROUSEL:
        return setBoardCarousel(state, action.payload);
      case GET_WINNER_HAND:
        return getWinnerHand(state);
      case SET_RULES:
        return setRules(state, action.payload);
      case SET_PLAYERS_COUNT:
        return setPlayersCount(state, action.payload);
      case SET_ACTIVE_FIELD:
        return setActiveField(state, action.payload);
      case RESET:
        return resetMenu(state);
      default:
        return state
    }
  }
);